import { LaunchFile } from '@/modules/controlCenterModule/components/robotConnection/loadLaunchFilesStrategy';
import { ConnectionDetails } from '@/modules/controlCenterModule/store';
import { PackageT } from '@/modules/nodesCanvasModule/components/storeClasses/packageT';
import { get, onValue, set, update } from 'firebase/database';
import { v4 } from 'uuid';
import { dbRef, V4UUID } from './database';
import { checkUserAdmin } from './databaseDependencyInjectables';

/**
File for connecting with the database of templates. 
Note: to upload templates the user needs to have the admin tag.
To give a user this tag, it must be manually entered into the firebase database.
the path looks like this: uid/admin
the admin tag is a boolean such that when true the user is an admin.
*/

export const getTemplates = (): Map<string, any> => {
  const ref = dbRef(`templates`);
  let templateDbInfo: any = {};
  onValue(ref, (snapshot: any) => {
    templateDbInfo = snapshot.val();
  });
  return templateDbInfo;
};

export const getTemplatesAsync = async (): Promise<
  Map<string, any> | undefined
> => {
  const ref = dbRef(`templates`);
  const snapshot = await get(ref);
  if (!snapshot.exists() || !snapshot.val()) return undefined;
  return snapshot.val();
};

export const uploadWsAsTemplate = (
  name: string,
  packages: Array<PackageT>,
  connectionDetails: ConnectionDetails,
  launchFiles: Array<LaunchFile> = [],
  image: undefined | string = undefined,
  id: V4UUID = v4()
) => {
  if (!checkUserAdmin()) return;
  const ref = dbRef(`templates/${id}`);
  let refVal = undefined;
  onValue(ref, (snapshot: any) => {
    refVal = snapshot.val() || false;
  });
  if (!refVal) {
    return set(
      ref,
      JSON.parse(
        JSON.stringify({
          name: name,
          connections: [connectionDetails],
          packages: packages,
          launchFiles: launchFiles,
          image: image
        })
      )
    );
  }
  return update(
    ref,
    JSON.parse(
      JSON.stringify({
        name: name,
        connections: [connectionDetails],
        launchFiles: launchFiles,
        packages: packages,
        image: image
      })
    )
  );
};

// export const updateTemplate = (id: V4UUID, name: string) => {

// }
